<div class="address-item"
     fxLayout="row"
     fxLayoutGap="10px"
     [ngClass]="addressItemClasses()"
     (click)="onSelectAddress(this.address.id)">

    <mat-icon>pin_drop</mat-icon>

    <!--    -->
    <div class="address-detail">

        <h3>{{this.address?.title}}</h3>

        <div class="address-info">{{addressText}}</div>
    </div>
    <!--    -->
    <div class="menu-container">
        <button mat-icon-button
                color="primary"
                [matMenuTriggerFor]="addressMenu">
            <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #addressMenu="matMenu">

            <button mat-menu-item (click)="onEdit()">
                <mat-icon color="primary">edit</mat-icon>
                <span translate="shared.labels.edit"></span>
            </button>

            <button mat-menu-item (click)="onRemove()">
                <mat-icon color="warn">delete_outline</mat-icon>
                <span translate="shared.labels.delete"></span>
            </button>
        </mat-menu>
    </div>
</div>
